import React from "react";
import { useNavigate } from "react-router-dom";
import paths from "../../routes/paths";
import { AiFillInstagram } from "react-icons/ai";
import Logo from "../../assets/images/commalax/Logo_white.png";


const Footer = () => {
  const navigate = useNavigate();
  const goHome = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    navigate(paths.home);
  };
  const goContact = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    navigate(paths.contact);
  };
  return (
    <div className="flex justify-center flex-col">
      <footer className="px-10 py-10 footer text-base-content ">
        <div>
          <span className="font-bold tracking-widest text-white ">
            <img src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLogo_white.png?alt=media&token=7cb41f18-4c50-4a50-8518-5b257b3dfae3" alt="" className="w-32" />
            {/* COMMALAX */}
          </span>
          <p className="text-white">
            Discover your beauty with us. ကိုရီးယားအလှကုန်များကို တစ်နေရာထဲမှာ
            ဝယ်ယူနိုင်ပါတယ်ရှင်။
          </p>
        </div>
        <div>
          <span className="footer-title tracking-wider ">Go to</span>
          <p onClick={goHome} className="link link-hover text-white">
            Home
          </p>
          <a
            href="https://commalax.com/"
            target={"_blank"}
            className="link link-hover text-white"
          >
            Shop
          </a>
          <p onClick={goContact} className="link link-hover text-white">
            Contact
          </p>
        </div>
        <div>
          <span className="footer-title tracking-wider ">Social</span>
          <div className="grid grid-flow-col gap-4">
            <a className="bg-white p-2 rounded-full cursor-pointer hover:scale-110 transition duration-150">
              <AiFillInstagram className="text-xl text-red-400" />
            </a>
            <a
              href="https://www.facebook.com/commalaxbeauty"
              target={"_blank"}
              className="bg-white p-2 rounded-full cursor-pointer hover:scale-110 transition duration-150"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                className="fill-current text-blue-500"
              >
                <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"></path>
              </svg>
            </a>
          </div>
        </div>
      </footer>
      <p className="mb-10 text-center text-sm text-white underline">
        Copyright © 2023 - All right reserved by Commalax
      </p>
    </div>
  );
};

export default Footer;
